import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { SourceBadge, nf, minuteTR } from "@/pages/market/ui";

/** Ana sayfa CIFTORA PİYASA bölümü: kullanıcının iline göre kısa özet + kaynak şeffaflığı. */
export default function MarketHomeSection() {
  const [data, setData] = useState(null);
  const [province, setProvince] = useState(null);

  useEffect(() => {
    api.get("/market/my-region").then((r) => setProvince(r.data)).catch(() => setProvince({}));
  }, []);

  useEffect(() => {
    if (province === null) return;
    api
      .get("/public/market/prices", { params: province.slug ? { province: province.slug } : {} })
      .then((r) => setData(r.data))
      .catch(() => setData(false));
  }, [province]);

  if (!data) return null;
  const rows = [...(data.province_prices || []), ...(data.national_prices || [])].slice(0, 6);
  if (rows.length === 0) return null;

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 lg:px-8" data-testid="market-home-section">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-sm uppercase tracking-wider font-semibold text-secondary">Ciftora Piyasa</p>
          <h2 className="mt-1 font-display text-2xl font-extrabold tracking-tight text-primary sm:text-3xl">
            {data.province ? `${data.province} ve Türkiye piyasası` : "Ticaret Borsası, ESK, UKON ve USK fiyatları"}
          </h2>
          <p className="mt-1 flex items-center gap-1.5 text-xs text-muted-foreground">
            <MapPin className="h-3.5 w-3.5" /> Kaynaklar ayrı gösterilir, tek fiyata dönüştürülmez.
          </p>
        </div>
        <Link
          to={data.province_slug ? `/fiyatlar/${data.province_slug}` : "/fiyatlar"}
          data-testid="market-home-all"
          className="inline-flex h-12 items-center gap-2 rounded-lg bg-primary px-5 text-sm font-bold text-primary-foreground hover:bg-secondary"
        >
          İl bazlı fiyatlar <ArrowRight className="h-4 w-4" />
        </Link>
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {rows.map((r) => (
          <article key={r.id} data-testid={`market-home-card-${r.id}`} className="rounded-lg border border-border bg-card p-6">
            <div className="flex items-start justify-between gap-3">
              <h3 className="text-sm font-bold text-primary">{r.source_product_name}</h3>
              <SourceBadge tier={r.source_tier} badge={r.source_badge} />
            </div>
            <p className="mt-3 text-2xl font-extrabold text-primary">
              {nf(r.price)}
              <span className="ml-1 text-sm font-semibold text-muted-foreground">{r.unit}</span>
            </p>
            <p className="mt-2 text-xs text-muted-foreground">
              {r.exchange_name || r.source_name} · {r.price_nature}
            </p>
            <p className="text-xs text-muted-foreground">
              Kaynak tarihi: {(r.transaction_date || r.published_at || "").slice(0, 10) || "belirtilmemiş"} ·
              Son kontrol: {minuteTR(r.last_checked_at) || "-"}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}
